// Keep track of the application available routes so there's no need to
// hand type every route.push()

enum AppRoutes {
	// Basic
	HOME = '/',

	GUIDE_STYLES = '/guide-styles',
	NOT_AUTHORIZED = '/not_authorized',
	NOT_FOUND = '/not_found',

	// Landing
	LANDING_ABOUT_US = '/about-us',
	LANDING_CONTACT_US = '/contact-us',
	LANDING_CASES = '/cases?page=1',
	LANDING_FILE_YOUR_CLAIM = '/file-your-claim',
	LANDING_FILE_YOUR_CLAIM_ID = '/file-your-claim/[id]',
	LANDING_CLAIM_EVALUATION = '/cases/claim-evaluation',
	LANDING_PRIVACY_POLICY = '/privacy-policy',
	LANDING_TERMS_OF_USE = '/terms-of-use',

	// -------------------- Client App -------------------------//
	// Auth routes
	CLIENTAPP_AUTH_FORGOT_PASSWORD = '/clientapp/auth/forgot-password',
	CLIENTAPP_AUTH_NEW_PASSWORD = '/clientapp/auth/new-password',
	CLIENTAPP_AUTH_SIGN_IN = '/clientapp/auth/signin',
	CLIENTAPP_AUTH_SIGN_UP = '/clientapp/auth/signup',
	CLIENTAPP_AUTH_REGISTER = '/clientapp/auth/register',
	CLIENTAPP_AUTH_SIGN_UP_SUCCESS = '/clientapp/auth/signup-success',
	CLIENTAPP_AUTH_TWO_FACTOR = '/clientapp/auth/two-factor',
	CLIENTAPP_AUTH_REACTIVATE_ACCOUNT = '/clientapp/auth/reactivate-account',
	CLIENTAPP_AUTH_REACTIVATE_ACCOUNT_PASSWORD = '/clientapp/auth/reactivate-account-password',
	CLIENTAPP_AUTH_REACTIVATE_ACCOUNT_REQUEST = '/clientapp/auth/reactivate-account-request',
	CLIENTAPP_AUTH_VERIFY_EMAIL = '/clientapp/auth/verify-email',
	CLIENTAPP_AUTH_VERIFY_EMAIL_FIRST_TIME = '/clientapp/auth/verify-email-first-time',
	// Logout aux page
	CLIENTAPP_AUTH_LOGOUT = '/clientapp/auth/logout',

	// App
	CLIENTAPP = '/clientapp',
	CLIENTAPP_DASHBOARD = '/clientapp/dashboard',
	CLIENTAPP_MY_CASES = '/clientapp/cases',
	CLIENTAPP_MY_CASE_DETAILS = '/clientapp/cases/[id]',
	CLIENTAPP_ALL_CASES = '/clientapp/all-cases',
	CLIENTAPP_ALL_CASES_FILE_YOUR_CLAIM = '/clientapp/all-cases/file-your-claim',
	CLIENTAPP_INBOX = '/clientapp/inbox',
	CLIENTAPP_FINANCIAL_RECOVERY = '/clientapp/financial-recovery',
	CLIENTAPP_SETTINGS = '/clientapp/settings',
	CLIENTAPP_SETTINGS_PERSONAL = '/clientapp/settings?tab=personal',
	CLIENTAPP_SETTINGS_CREDENTIALS = '/clientapp/settings?tab=credentials',
	CLIENTAPP_SETTINGS_PAYMENT = '/clientapp/settings?tab=payment',
	CLIENTAPP_SETTINGS_NOTIFICATIONS = '/clientapp/settings?tab=notifications',
	CLIENTAPP_CLAIM_CHAT = '/clientapp/claim-chat',
	CLIENTAPP_CUSTOMER_SUPPORT = '/clientapp/customer-support',

	// --------------------- Lawyer App ------------------------//
	// Auth routes
	LAWYERAPP_AUTH_FORGOT_PASSWORD = '/lawyerapp/auth/forgot-password',
	LAWYERAPP_AUTH_SET_NEW_PASSWORD = '/lawyerapp/auth/set-new-password',
	LAWYERAPP_AUTH_COMPLETE_ACCOUNT_DETAILS = '/lawyerapp/auth/complete-account-details',
	LAWYERAPP_AUTH_VERIFY_PHONE = '/lawyerapp/auth/verify-phone',
	LAWYERAPP_AUTH_SIGN_IN = '/lawyerapp/auth/signin',
	LAWYERAPP_AUTH_SIGN_UP = '/lawyerapp/auth/signup',
	LAWYERAPP_AUTH_TWO_FACTOR = '/lawyerapp/auth/two-factor',
	LAWYERAPP_CLIENTS = '/lawyerapp/cases/[id]/clients',
	LAWYERAPP_CASES_ADMINISTRATION = '/lawyerapp/cases/[id]/administration',
	// Logout aux page
	LAWYERAPP_AUTH_LOGOUT = '/lawyerapp/auth/logout',
	// App

	LAWYERAPP = '/lawyerapp',
	LAWYERAPP_DASHBOARD = '/lawyerapp/dashboard',
	LAWYERAPP_CASES = '/lawyerapp/cases',

	// Case Creation
	LAWYERAPP_CREATE_CASE = '/lawyerapp/cases/create',
	LAWYERAPP_INVESTIGATION_PHASE = '/lawyerapp/cases/[id]/investigation',
	LAWYERAPP_APPLICANT_INTAKE_PHASE = '/lawyerapp/cases/[id]/applicant-intake',
	LAWYERAPP_ACTIVE_CASE_PHASE = '/lawyerapp/cases/[id]/active-case',
	LAWYERAPP_SETTLEMENT_PHASE = '/lawyerapp/cases/[id]/settlement',

	// Settins
	LAWYERAPP_SETTINGS = '/lawyerapp/settings',
	LAWYERAPP_SETTINGS_PERSONAL = '/lawyerapp/settings?tab=personal',
	LAWYERAPP_SETTINGS_CREDENTIALS = '/lawyerapp/settings?tab=credentials',
	LAWYERAPP_SETTINGS_NOTIFICATIONS = '/lawyerapp/settings?tab=notifications',

	// Client Directory
	LAWYERAPP_CLIENT_DIRECTORY = '/lawyerapp/client-directory',
	LAWYERAPP_CLIENT_DIRECTORY_CLEANUP_WIZARD = '/lawyerapp/client-directory/cleanup-wizard',
	LAWYERAPP_CLIENT_ANALYTICS = '/lawyerapp/analytics',

	// Marketing
	LAWYERAPP_MARKETING = '/lawyerapp/marketing',
	LAWYERAPP_MARKETING_CLIENT_TARGETING = '/lawyerapp/marketing/client-targeting',
	LAWYERAPP_MARKETING_PERFORMANCE = '/lawyerapp/marketing/performance',
	LAWYERAPP_MARKETING_NEW_CAMPAIGN = '/lawyerapp/marketing/campaign/new-campaign',
	LAWYERAPP_MARKETING_CAMPAIGN = '/lawyerapp/marketing/campaign',
	LAWYERAPP_MARKETING_CAMPAIGN_SCHEDULE = '/lawyerapp/marketing/campaign/schedule',
	LAWYERAPP_INBOX = '/lawyerapp/inbox',

	// Client Profile
	LAWYERAPP_CLIENT_PROFILE = '/lawyerapp/client-profile/',
	LAWYERAPP_CLIENT_PROFILE_ID = '/lawyerapp/client-profile/[id]',
	LAWYERAPP_CLIENT_PROFILE_DASHBOARD = '/lawyerapp/client-profile/[id]/?tab=dashboard',
	LAWYERAPP_CLIENT_PROFILE_ACCOUNT_DETAILS = '/lawyerapp/client-profile/[id]/?tab=account-details',
	LAWYERAPP_CLIENT_PROFILE_CASES = '/lawyerapp/client-profile/[id]/?tab=cases',
	LAWYERAPP_CLIENT_PROFILE_BRANS_USED = '/lawyerapp/client-profile/[id]/?tab=brands-used',
	LAWYERAPP_ADMIN_PANEL = '/lawyerapp/admin',
	// Others
	// Email related
	EMAIL_CONTENT_EDITOR = '/email/contentEditor',
	EMAIL_TEMPLATES_LIST = '/email/templatesList',
}

export default AppRoutes;
